<template>
  <v-row>
    <v-col v-for="rule in rules" :key="rule.key" :cols="rule?.cols ?? 4">
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">
            <v-checkbox
              v-if="rule.type == 'checkbox'"
              v-model="localForm[rule.key]"
              :label="rule.label"
              color="primary"
              required
              dense
              @change="emitChange"
            />
          </span>
        </template>
        <span>{{ rule.description }}</span>
      </v-tooltip>

      <v-text-field
        v-if="rule.type == 'number'"
        v-model="localForm[rule.key]"
        :label="rule.label"
        :hint="rule.description"
        required
        clearable
        type="number"
        dense
        @input="emitChange"
      ></v-text-field>

      <v-autocomplete
        v-if="rule.type == 'inputSelect'"
        v-model="localForm[rule.key]"
        :label="rule.label"
        :items="fieldsByType(rule?.properties?.inputSelectType, fields)"
        :hint="rule.description"
        item-text="label"
        item-value="name"
        required
        dense
        clearable
        chips
        small-chips
        deletable-chips
        :multiple="!!rule.properties?.multiple"
        @change="emitChange"
      >
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title>{{ item.label }}</v-list-item-title>
            <v-list-item-subtitle>{{ item.name }}</v-list-item-subtitle>
          </v-list-item-content>
        </template>
        <template v-slot:selection="{ item, index }">
          <v-chip
            small
            close
            :title="item.label"
            @click:close="localForm[rule.key].splice(index, 1)"
          >
            {{ item.label }}
          </v-chip>
        </template>
      </v-autocomplete>

      <v-row v-if="rule.type == 'minimumTimePiker'">
        <v-col cols="12"><span class="caption">Data e Hora mínima</span></v-col>

        <v-col cols="6">
          <v-autocomplete
            v-if="localForm.minimumTimePiker && localForm.minimumTimePiker[0]"
            v-model="localForm.minimumTimePiker[0].value"
            label="Campo de data mínima"
            :items="getFieldsByComponentType('datePiker')"
            :hint="rule.description"
            item-text="label"
            item-value="name"
            required
            dense
            clearable
            @change="emitChange"
          />
        </v-col>

        <v-col cols="6">
          <v-autocomplete
            v-if="localForm.minimumTimePiker && localForm.minimumTimePiker[1]"
            v-model="localForm.minimumTimePiker[1].value"
            label="Campo de hora mínima"
            :items="getFieldsByComponentType('timePiker')"
            :hint="rule.description"
            item-text="label"
            item-value="name"
            required
            dense
            clearable
            @change="emitChange"
          />
        </v-col>

        <v-col cols="6">
          <v-text-field
            v-if="localForm.minimumTimePiker && localForm.minimumTimePiker[2]"
            v-model="localForm.minimumTimePiker[2].value"
            v-mask="'##:##:##'"
            :label="rule.label"
            placeholder="(HH:MM:SS)"
            hint="Tempo em horas, minutos e segundos"
            :rules="timeRules"
            required
            clearable
            dense
            @input="emitChange"
          />
        </v-col>
      </v-row>

      <v-row
        v-if="
          rule.key == 'defaultValue' ||
          rule.key == 'autoDate' ||
          rule.key == 'autoTime'
        "
      >
        <v-col>
          <v-select
            v-if="rule.type == 'inputOptions'"
            v-model="localForm[rule.key]"
            :label="rule.label"
            :items="rule.options"
            :hint="rule.description"
            item-text="label"
            item-value="key"
            required
            dense
            clearable
            @change="emitChange"
          >
          </v-select>
        </v-col>
      </v-row>

      <v-row v-if="rule.key == 'fieldCalculated'">
        <Calculate v-model="localForm[rule.key]" @input="emitChange" />
      </v-row>

      <v-row v-if="rule.key == 'timeCalculated'">
        <Calculate
          v-model="localForm[rule.key]"
          time-only
          @input="emitChange"
        />
      </v-row>

      <v-row v-if="rule.key == 'text'">
        <v-col v-if="textLoading">
          <p class="caption">
            Colocar entre {} o nome do componente, exemplo: {Valor da visita}
          </p>
          <TiptapVuetify
            v-model="localForm[rule.key]"
            class="tiptap"
            placeholder="Digite o texto"
            :extensions="extensions"
            :toolbar-attributes="{ color: 'primary', dark: true }"
            @input="emitChange"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import {
  Blockquote,
  Bold,
  BulletList,
  Code,
  HardBreak,
  History,
  HorizontalRule,
  Italic,
  ListItem,
  OrderedList,
  Paragraph,
  Strike,
  TiptapVuetify,
  Underline,
} from 'tiptap-vuetify'
import { mapActions, mapState } from 'vuex'
import Compoents from '../../../services/StructureReport/Structure'
import { LOAD_ALL_FIELDS } from '../../../vuex/modules/structure'
import Calculate from './components/Calculate.vue'

export default {
  name: 'Rules',

  components: {
    Calculate,
    TiptapVuetify,
  },

  props: {
    rules: {
      type: Array,
      required: true,
    },

    value: {
      type: [Array, Object],
      required: true,
    },
  },

  data() {
    return {
      Compoents,
      textLoading: false,
      localForm: {},
      fields: [],
      extensions: [
        History,
        Blockquote,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        Bold,
        HorizontalRule,
        Paragraph,
        HardBreak,
        Code,
      ],
      timeRules: [
        v => !!v || 'Este campo é obrigatório',
        v => {
          if (!v) return true
          const timeRegex = /^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/
          return (
            timeRegex.test(v) ||
            'Insira uma hora válida entre 00:00:00 e 23:59:59'
          )
        },
      ],
    }
  },

  computed: {
    ...mapState('structure', ['data', 'loading', 'project']),
  },

  watch: {
    value: {
      handler(newValue) {
        if (newValue && this.fields.length > 0) {
          this.syncInitialValues()
        }
      },
      immediate: true,
      deep: true,
    },
  },

  created() {
    this.getFields().then(() => {
      this.listFieldsInText()
      this.syncInitialValues()
    })
  },

  methods: {
    ...mapActions('structure', [LOAD_ALL_FIELDS]),

    emitChange() {
      // Varre as regras para garantir que campos simples nunca mantenham arrays
      this.rules.forEach(rule => {
        if (rule.type === 'inputSelect') {
          const isMultiple = !!rule.properties?.multiple
          const val = this.localForm[rule.key]

          if (isMultiple) {
            if (!Array.isArray(val)) {
              this.localForm[rule.key] = val ? [val] : []
            }
          } else {
            if (Array.isArray(val)) {
              this.localForm[rule.key] = val.length > 0 ? val[0] : null
            }
          }
        }
      })

      this.$emit('input', { ...this.localForm })
    },

    syncInitialValues() {
      if (this.value) {
        const parsed = Array.isArray(this.value)
          ? { ...this.value }
          : { ...this.value }

        this.rules.forEach(rule => {
          if (rule.type === 'inputSelect') {
            const isMultiple = !!rule.properties?.multiple
            let val = parsed[rule.key]

            // Se o banco salvou como string JSON (ex: "[\"A\",\"B\"]"), converte para Array real
            if (typeof val === 'string' && val.trim().startsWith('[')) {
              try {
                val = JSON.parse(val)
              } catch (e) {
                // Se falhar o parse, tenta tratar como string separada por vírgula normal
                val = val.length > 0 ? val.split(',') : []
              }
            }

            if (isMultiple) {
              if (!Array.isArray(val)) {
                if (typeof val === 'string' && val.length > 0) {
                  parsed[rule.key] = val.split(',')
                } else {
                  parsed[rule.key] = []
                }
              } else {
                parsed[rule.key] = val
              }
            } else {
              // Se NÃO for múltiplo, garante que seja apenas um valor primitivo único
              if (Array.isArray(val)) {
                parsed[rule.key] = val.length > 0 ? val[0] : null
              } else {
                parsed[rule.key] = val !== undefined ? val : null
              }
            }
          }

          // Trata checkboxes para garantir booleano real (true/false)
          if (rule.type === 'checkbox') {
            const val = parsed[rule.key]
            parsed[rule.key] =
              val === 'true' || val === true || val === 1 || val === '1'
          }
        })

        this.localForm = { ...parsed }
      }
    },

    async getFields() {
      this.fields = await this.LOAD_ALL_FIELDS()
    },

    getFieldsByComponentType(componentType) {
      return this.fields.filter(field => field.componentType === componentType)
    },

    fieldsByType(type, list = this.fields) {
      if (!list) return []

      return list.reduce((acc, field) => {
        // Verifica se tem 'name' e 'label' válidos
        const hasNameAndLabel = field && field.name && field.label

        // Verifica o tipo (se informado)
        const matchesType = !type || field.type === type

        // Se atende a todas as condições, adiciona ao acumulador
        if (hasNameAndLabel && matchesType) {
          acc.push(field)
        }

        // Busca recursivamente dentro de 'treeViewChildren'
        if (field.treeViewChildren && field.treeViewChildren.length > 0) {
          acc.push(...this.fieldsByType(type, field.treeViewChildren))
        }

        return acc
      }, [])
    },

    listFieldsInText() {
      this.textLoading = false

      const rule = this.rules.find(rule => rule.key === 'text')
      if (!rule) {
        this.textLoading = false
        return
      }

      const keys = this.value?.value

      const fields = this.fields
        .filter(field => keys?.includes(field.name))
        .map(field => {
          if (!field.label) {
            return {
              name: field.name,
              label:
                '<code style="color: #c24f4f">Titulo do campo não encontrado!</code>',
            }
          }
          return {
            name: field.name,
            label: field.label,
          }
        })

      let text = this.value?.text || ''

      fields.forEach(field => {
        const find = `{${field.name}}`
        text = text.replaceAll(find, `{${field.label}}`)
      })

      this.localForm.text = text
      this.textLoading = true

      return fields
    },
  },
}
</script>

<style>
.tiptap {
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  overflow-y: auto;
  background-color: #fff;
  color: #000;
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  line-height: 1.5;
  transition: border-color 0.2s;
}
.tiptap .ProseMirror {
  padding: 4px;
}
</style>
